<template>
    <div style="vertical-align:bottom;">
        <div class="topbar-logo2"><img src="@/assets/logo.svg" class="topbar-logo2"/></div>
        <div  class="topbar-title2">
            <span>coffice</span>
        </div>
        <div style="float:right;display:inline-block;text-align:center;line-height:50px;vertical-align:bottom;">
          <el-avatar :size="30" :src="circleUrl" style="margin-top:15px"/>
          <el-dropdown @command="command" style="vertical-align:middle;">
            <span class="el-dropdown-link">
              {{username}}<i class="el-icon-caret-bottom"></i>	
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">修改密码</el-dropdown-item>
              <el-dropdown-item command="2">基本信息</el-dropdown-item>
              <el-dropdown-item divided  command="3">退出</el-dropdown-item>
            <!-- <el-button type="info" @click="logout">退出</el-button> -->
            </el-dropdown-menu>
        </el-dropdown>
    </div>
    </div>
  </template>
  <script>
  export default {
      name: 'Home',
      data() {
        return {
          username:localStorage.getItem('username'),
          circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        }
      },
      methods: {
        command(index){
        		switch(index){
	        		case '1':
	        			this.toClick('修改密码','updateadmin')
	        			break;
	        		case '2':
	        			break;
	        		case '3':
                        this.logout();
	        			break
        		}
        	},
        logout () {
            localStorage.clear();
            this.$router.push('/login');
            this.$notify({
            title: '提示',
            message: '退出成功',
            duration: 3000
          });
            }
        }
  }
  </script>
  <style scoped>
.topbar-logo{width:49px;line-height:60px}
.topbar-logo,.topbar-title{float:left;text-align:center}
.topbar-title{width:129px;vertical-align:bottom;font-size: 32px;color:#fff}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/components/Header.vue